export default "__VITE_ASSET__JTFCKvPr__"